import { Link } from '@tanstack/react-router'
import { Settings, ShieldCheck } from 'lucide-react'
import type { FamilyUser } from '@shared/types'
import { initials } from '@/lib/utils'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { avatarImageUrl } from '@/lib/avatar-image'
import { Button } from '@/components/ui/button'
import { ThemeCycleButton } from '@/components/theme-picker'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function AccountMenu({ user }: { user: FamilyUser }) {
  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button type="button" variant="ghost" size="icon" className="account-trigger size-12 rounded-full p-1" aria-label="Open account menu" title="Account">
        <Avatar size="lg">
          <AvatarImage src={avatarImageUrl(user.image, 80)} alt="" />
          <AvatarFallback style={{ backgroundColor: user.cursorColor, color: '#fff' }}>{initials(user.name || user.email) || '?'}</AvatarFallback>
        </Avatar>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" sideOffset={8} className="w-64">
      <DropdownMenuLabel className="grid gap-0.5 px-2 py-2">
        <span className="truncate font-semibold" title={user.name}>{user.name}</span>
        <span className="truncate text-xs font-normal text-muted-foreground" title={user.email}>{user.email}</span>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild onSelect={(event) => event.preventDefault()}><ThemeCycleButton className="w-full justify-start px-2" /></DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild><Link to="/settings"><Settings className="size-4" />Settings</Link></DropdownMenuItem>
      {user.role === 'admin' && <DropdownMenuItem asChild><Link to="/admin/users"><ShieldCheck className="size-4" />Approvals</Link></DropdownMenuItem>}
    </DropdownMenuContent>
  </DropdownMenu>
}
